import { render, staticRenderFns } from "./CustomerPage.vue?vue&type=template&id=35507297&"
import script from "./CustomerPage.vue?vue&type=script&lang=js&"
export * from "./CustomerPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPage.vue?vue&type=style&index=0&id=35507297&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports